import { render, staticRenderFns } from "./signIn.vue?vue&type=template&id=aaf48e22"
import script from "./signIn.vue?vue&type=script&lang=js"
export * from "./signIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports